<template lang="pug">
  .view-control-reports-tests
    statistic(url="/statistics/tests-progress" has-export expanded @expand="goToDetailedView")
</template>

<script>
export default {
  name: 'view-control-reports-tests',

  methods: {
    goToDetailedView(testId, userId) {
      if (userId) {
        this.$router.push({
          name: 'control.reports.detailed-test',
          params: { testId, userId },
        });
      } else {
        this.$router.push({
          name: 'control.reports.test',
          params: { testId },
        });
      }
    },
  },
};
</script>
